export default "__VITE_ASSET__Cid3AKta__"